/**
 * Utility functions for updating document title and favicon dynamically
 */

import appConfig from '../../app.config';

/**
 * Update the document title
 * @param {string} title - The title to set (will be combined with app title)
 */
export function updateDocumentTitle(title) {
  if (title) {
    document.title = title + ' | ' + appConfig.title;
  }
}

/**
 * Update the favicon dynamically
 * @param {string} faviconUrl - URL or path to the favicon
 */
export function updateFavicon(faviconUrl) {
  if (!faviconUrl) return;

  // Remove existing favicon links
  const existingLinks = document.querySelectorAll("link[rel*='icon']");
  existingLinks.forEach(link => link.remove());

  // Create new favicon link
  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = getFaviconType(faviconUrl);
  link.href = faviconUrl;
  
  // Add to head
  document.head.appendChild(link);
}

/**
 * Get the appropriate MIME type for favicon based on file extension
 * @param {string} url - The favicon URL
 * @returns {string} MIME type
 */
function getFaviconType(url) {
  const extension = url.split('.').pop().toLowerCase();
  const typeMap = {
    'ico': 'image/x-icon',
    'png': 'image/png',
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'gif': 'image/gif',
    'svg': 'image/svg+xml'
  };
  return typeMap[extension] || 'image/x-icon';
}

/**
 * Initialize document settings from general settings
 * @param {Object} settings - Settings object with title and favicon
 */
export function initializeDocumentSettings(settings) {
  if (settings) {
    if (settings.title) {
      // Store the base title for use in router
      localStorage.setItem('appTitle', settings.title);
    }
    if (settings.favicon) {
      updateFavicon(settings.favicon);
    }
  }
}

/**
 * Get the base title from settings or config
 * @returns {string} Base title
 */
export function getBaseTitle() {
  const storedTitle = localStorage.getItem('appTitle');
  if (storedTitle) {
    return storedTitle;
  }
  return appConfig.title;
}

